module.exports = __webpack_public_path__ + "h5/img/open.aa1732dc.gif";